// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.state-button_2e78aa83 {
  display: inline-flex;
  align-items: center;
  position: relative;
}
.state-button__handler_2e78aa83 {
  opacity: 0;
  position: absolute;
  pointer-events: none;
}
.state-button__handler_2e78aa83:checked ~ .state-button__caption_on_2e78aa83 {
  font-weight: 400;
}
.state-button__handler_2e78aa83:checked ~ .state-button__caption_off_2e78aa83 {
  font-weight: 400;
}
.state-button__handler_2e78aa83:checked ~ .state-button__box_2e78aa83 {
  background-color: #1d5080;
  border-color: #1d5080;
  color: inherit;
  opacity: 1;
  cursor: pointer;
}
.state-button__handler_2e78aa83:checked ~ .state-button__box_2e78aa83:hover {
  box-shadow: 0 0 0 2px #c4edeb;
}
.state-button__handler_2e78aa83:checked ~ .state-button__box_2e78aa83::before,
.state-button__handler_2e78aa83:checked ~ .state-button__box_2e78aa83::after {
  border-color: #1d5080;
}
.state-button__handler_2e78aa83:checked ~ .state-button__box_2e78aa83::before {
  left: calc(100% - 1.251rem);
}
.state-button__handler_2e78aa83:disabled ~ .state-button__caption_2e78aa83 {
  font-weight: 400;
  color: #c1c8cd;
}
.state-button__handler_2e78aa83:disabled ~ .state-button__box_2e78aa83 {
  background-color: #eaedef;
  border-color: #c1c8cd;
  color: #c1c8cd;
  opacity: 0.5;
  cursor: default;
}
.state-button__handler_2e78aa83:disabled ~ .state-button__box_2e78aa83:hover {
  box-shadow: none;
}
.state-button__handler_2e78aa83:disabled ~ .state-button__box_2e78aa83::before,
.state-button__handler_2e78aa83:disabled ~ .state-button__box_2e78aa83::after {
  border-color: #c1c8cd;
}
.state-button__handler_2e78aa83:disabled ~ .state-button__box_2e78aa83::before,
.state-button__handler_2e78aa83:disabled ~ .state-button__box_2e78aa83::after {
  border-color: #c1c8cd;
}
.state-button__handler_2e78aa83:disabled ~ .state-button__box_2e78aa83:hover,
.state-button__handler_2e78aa83:disabled ~ .state-button__box_2e78aa83:active {
  box-shadow: none;
  cursor: default;
}
.state-button__handler_2e78aa83:disabled:checked ~ .state-button__box_2e78aa83 {
  background-color: #eaedef;
  border-color: #c1c8cd;
  color: #c1c8cd;
  opacity: 0.5;
  cursor: default;
}
.state-button__handler_2e78aa83:disabled:checked ~ .state-button__box_2e78aa83:hover {
  box-shadow: none;
}
.state-button__handler_2e78aa83:disabled:checked ~ .state-button__box_2e78aa83::before,
.state-button__handler_2e78aa83:disabled:checked ~ .state-button__box_2e78aa83::after {
  border-color: #c1c8cd;
}
.state-button__handler_2e78aa83:disabled:checked ~ .state-button__box_2e78aa83::before,
.state-button__handler_2e78aa83:disabled:checked ~ .state-button__box_2e78aa83::after {
  border-color: #c1c8cd;
}
.state-button__handler_2e78aa83:disabled:checked ~ .state-button__box_2e78aa83::before {
  left: calc(100% - 1.251rem);
}
.state-button__handler_2e78aa83:focus-visible ~ .state-button__box_2e78aa83 {
  outline-style: solid;
  outline-offset: 1px;
  outline-width: 2px;
  outline-color: #1d5080;
  box-shadow: 0 0 0 4px #fff;
  transition: box-shadow 0s, outline 0s;
}
.state-button__caption_2e78aa83 {
  display: inline-block;
  font-family: PitchBookFont, 'Helvetica', 'Arial', sans-serif;
  font-size: 1rem;
  line-height: 1;
  letter-spacing: normal;
  font-stretch: normal;
}
.state-button__caption_on_2e78aa83 {
  font-weight: 400;
  margin-left: 0.667rem;
}
.state-button__caption_off_2e78aa83 {
  font-weight: 400;
  margin-right: 0.667rem;
}
.state-button__box_2e78aa83 {
  position: relative;
  height: 1.334rem;
  width: 30px;
  border-radius: 1.334rem;
  transition: all 0.2s linear;
  background-color: #c1c8cd;
  border-color: #84919b;
  color: inherit;
  opacity: 1;
  cursor: pointer;
}
.state-button__box_2e78aa83:hover {
  box-shadow: 0 0 0 2px #c4edeb;
}
.state-button__box_2e78aa83::after {
  content: '';
  border: 0.084rem solid #84919b;
  position: absolute;
  z-index: 0;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  border-radius: 2rem;
  transition: all 0.2s linear;
}
.state-button__box_2e78aa83::before {
  content: '';
  position: absolute;
  z-index: 10;
  top: 1px;
  left: 1px;
  width: 1.167rem;
  min-width: 1.167rem;
  height: 1.167rem;
  border: 0.084rem solid #84919b;
  border-radius: 50%;
  background-color: #fff;
  transition: all 0.2s linear;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"state-button": `state-button_2e78aa83`,
	"state-button__handler": `state-button__handler_2e78aa83`,
	"state-button__caption_on": `state-button__caption_on_2e78aa83`,
	"state-button__caption_off": `state-button__caption_off_2e78aa83`,
	"state-button__box": `state-button__box_2e78aa83`,
	"state-button__caption": `state-button__caption_2e78aa83`
};
export default ___CSS_LOADER_EXPORT___;
